import React, { Component } from 'react';
import socketIOClient from "socket.io-client";
import { withRouter } from 'react-router-dom';
import {
	Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';

import logo              from '../images/logo.svg';
import LoadManagerCenter from './LoadManagerCenter';
import SearchJumper      from './modals/searchJumper';
import jumpersStore      from '../../stores/jumpers-store';
import loadsStore        from '../../stores/loads-store';
import authStore         from '../../stores/auth-store';
import { urls }          from '../../const.js'
import ViewDetail        from './modals/jumperDetail';

import DailyActivity from './DailyActivity';
import { makeStyles } from '@material-ui/core/styles';

import BottomNav from './bottomNav';
// import RestoreIcon from '@material-ui/icons/Restore';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import LocationOnIcon from '@material-ui/icons/LocationOn';
import StaffCheckin from './modals/staffCheckin'
import NavHamburger from './NavHamburger/NavContainer';

const useStyles = makeStyles({
	root: {
		width: 500,
	},
});

class CenterComponent extends Component {
	constructor(props) {
		super(props);
		this.loadSettings = {}
		if (localStorage.getItem('jumperDetails')) {
			const { columnsPerGroup, fontSize, loadsPerPage } = JSON.parse(localStorage.getItem('jumperDetails'))
			this.loadSettings = { columnsPerGroup, fontSize, loadsPerPage }
		}
		this.handleLogout = this.handleLogout.bind(this);
		this.state = {
			showModal: false,
			isLoading: true,
			dailyActivity: {},
			componentToRender: 1,
			jumperId: '',

			loadsToShow: this.loadSettings.loadsPerPage,
			columnsPerGroup: this.loadSettings.columnsPerGroup ,
			fontSize: this.loadSettings.fontSize

			// loadsToShow: 4,
			// columnsPerGroup: 3,
			// fontSize: 14
		}
		this.jumperEvents = [
			//removed event
		];
	}

	componentDidMount() {
		console.log("ers", this.props.settingObj)
		if (this.props.history && this.props.history.location && this.props.history.action === "PUSH") {
			const socket = socketIOClient(urls.mainApiUrl);
			jumpersStore.loadAllJumpers()
				.then((jumpersLoaded) => {
					return jumpersStore.loadTandemStudents();
				})
				.then((studentsLoaded) => {
					return loadsStore.loadAllExistingLoads();
				})
				.then(loads => {
					loadsStore.setListeners(socket);
				})
		}
	}

	componentWillMount() {
		this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));
	}
	componentWillUnmount() {
		this.jumperEvents.forEach((evnt) => jumpersStore.removeListener(evnt.name, evnt.func));
	}
	handleJumpersLoaded = (jumperOptions) => {
		this.setState({
			jumperOptions: jumperOptions
		});
	}
	handleLogout() {
		localStorage.clear();
		clearInterval(loadsStore.scrollTimer)
		clearInterval(loadsStore.scrollTimer1)
		authStore.logout();
		this.props.history.push('/login')
	}
	isLoading = (data) => {
		this.setState({
			loading: data
		})
	}

	// renderComponent = () => {

	// 	handelTabs  = (value) => {
	// 		switch (value) {
	// 			case 0:
	// 				this.props.history.push('/daily-activity')
	// 				return
	// 			case 1:
	// 				return
	// 			case 2:
	// 				this.props.history.push('/detail')
	// 				return

	// 			default:
	// 				break;
	// 		}
	// 	}


	// }

	// handelTabs  = (value) => {
	// 	switch (value) {
	// 		case 0:
	// 			return <LoadManagerCenter isLoading={this.isLoading} routeHistory={this.props.history} />
	// 		case 1:
	// 			return <DailyActivity disableComp={() => this.setState({ componentToRender: 'default' })} />
	// 		case 2:
	// 			return <Detail disableComp={() => this.setState({ componentToRender: 'default' })} />

	// 		default:
	// 			break;
	// 	}
	// }

	giveSettings = (payload) => {
		this.setState({
			columnsPerGroup: payload.columnsPerGroup,
			loadsToShow: payload.loadsPerPage,
			fontSize: payload.fontSize
		})
	}

	render() {
		var getMargin = (this.props.noMargin ? '5vh' : '15vh');
		let jumperDetails = localStorage.getItem('jumperDetails')
		let fontSizeLocalize = 12
		console.log("ers", this.props)

		if (localStorage.getItem('fontSize')) {
			fontSizeLocalize = localStorage.getItem('fontSize')
		}

		const override = `
	        display: block;
	        margin: 0 auto;
	        border-color: red;
          `;
		let { componentToRender, loading, fontSize, columnsPerGroup, loadsToShow } = this.state
		const settingObj = { fontSize, columnsPerGroup, loadsToShow }
		return (
			<div className="col"
				style={{ height: '100vh' }}
			>

				<Modal id="modal-report" aria-labelledby="example-custom-modal-styling-title"
					isOpen={false} style={{ zIndex: '10503434', right: '28%' }}>
					<ModalHeader>View Details</ModalHeader>
					<ModalBody>
						<Row className="form-group">
							<Col md={12}>
								{/* {this.renderSummary()} */}
							</Col>
						</Row>

						<div className="ViewAccounts-totalSection-246" style={{ paddingTop: 10, paddingBottom: 10 }}>

							<table className="StaffSummary" style={{ marginLeft: '6px', width: '97%' }}>
								<tbody>
									{/*	<tr>
									<td>PREVIOUS BALANCE </td>
									<td>{currentBalanceString !== "($ undefined)" ? currentBalanceString : "$0"}</td>
							</tr> */}
									<tr>
										<td>TODAYS BALANCE </td>
										<td> 22</td>
									</tr>
									<tr>
										<td>TOTAL PAID </td>
										<td>33</td>
									</tr>
									{/* <tr>
									<td>TOTAL BALANCE </td>
									<td>{totalBalanceString !== "($undefined)" ? totalBalanceString : "$0"}</td>
								</tr> */}
								</tbody>
							</table>
						</div>

						<Row className="form-group m-t-2-rem">
							<Col md={{ size: 9 }}>
								<button onClick={(e) => { e.preventDefault(); this.closeModal(); }} className="btn btn-link">CANCEL</button>
							</Col>
						</Row>
					</ModalBody>
				</Modal>


				<img src={logo} alt="logo" className={`dizio-logo diziooLogo`} />
				{
					jumperDetails != 'undefined' ? '' : <img src={logo} alt="logo" class={`dizio-logo`} />
				}
				{/* {localStorage.getItem("role") !=="video edit"?
					<span className="staff-checkin-btn"><StaffCheckin /></span>:null
				} */}

				<NavHamburger settingObj={settingObj} giveSettings={this.giveSettings} _handleSettings={this._handleSettings} />

				{/* <span className="logout">
					<span onClick={this.handleLogout}>
						Logout <i className="fa fa-sign-out" />
					</span>
				</span> */}


				<div className="row" style={{ width: '100%', margin: 'auto', fontSize: `${this.state.fontSize}px`, marginTop: getMargin, marginTop: '0px' }}>
					{/* {this.props.renderThis.center} */}

					{/* {!this.state.loading && <SearchJumper
                        options={jumpersStore.getJumperOptions()}
                        mode="async" placeholder="search jumper" />} */}
					{/* {this.renderComponent()} */}


					<LoadManagerCenter
						settingObj={settingObj}
						isLoading={this.isLoading}
						routeHistory={this.props.history}
					/>
				</div>
				{
					jumperDetails !== 'undefined' && <BottomNav history={this.props.history} componentToRender={1} />
				}
			</div>
		);
	}
}

export default withRouter(CenterComponent);
